import { useState } from 'react';
import { Box, Typography, FormControl, FormHelperText } from '@mui/material';
import DocumentUploader from '@/components/shared/DocumentUploader';
import type { FileUploadFieldProps } from '@/types';

export default function FileUploadField({
  error,
  setValue,
  setError,
  setChanged,
}: FileUploadFieldProps): React.JSX.Element {
  const [uploadedTitle, setUploadedTitle] = useState<string>('');

  const handleDocuments = (documents: Array<{ title: string }>): void => {
    if (documents && documents.length > 0) {
      setChanged();
      setValue(documents[0]);
      setUploadedTitle(documents[0].title);
      setError(false);
    } else {
      setError('Document file is required');
    }
  };

  return (
    <Box>
      <FormControl fullWidth required error={Boolean(error)}>
        <Typography variant='subtitle1' gutterBottom>
          Document File
        </Typography>
        <DocumentUploader
          setDocuments={handleDocuments}
          disabled={false}
          replacing={Boolean(uploadedTitle)}
          label={uploadedTitle ? 'Replace Document' : 'Upload Document'}
          tooltip={
            uploadedTitle
              ? 'Upload again to replace document'
              : 'Upload a document'
          }
        />
        {uploadedTitle && (
          <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
            Uploaded: {uploadedTitle}
          </Typography>
        )}
        {error ? <FormHelperText>{error}</FormHelperText> : undefined}
      </FormControl>
    </Box>
  );
}
